import { render } from "./Pages.vue?vue&type=template&id=12822b34"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"

import "./Pages.vue?vue&type=style&index=0&id=12822b34&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__